module.exports = __webpack_public_path__ + "img/sina02.29fea9f5.png";